import { getFirestore, doc, updateDoc, Timestamp } from "firebase/firestore";
import { mapFirebaseError } from "./errorMapper";
export class FirebaseAccountDeletionRepository {
    db = getFirestore();
    async requestDeletion(userId, recoveryWindowDays = 60) {
        try {
            const now = Timestamp.now();
            const scheduled = Timestamp.fromMillis(now.toMillis() + recoveryWindowDays * 86400 * 1000);
            await updateDoc(doc(this.db, "users", userId), {
                deletionRequestedAt: now,
                deletionScheduledAt: scheduled,
            });
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async cancelDeletion(userId) {
        try {
            await updateDoc(doc(this.db, "users", userId), {
                deletionRequestedAt: null,
                deletionScheduledAt: null,
            });
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
}
//# sourceMappingURL=FirebaseAccountDeletionRepository.js.map